module.exports = __webpack_public_path__ + "img/1.307fdd45.jpeg";